import React, { FC, ReactNode, useCallback } from 'react'
import styled from 'styled-components'

import colors, { $white, $gray_100 } from 'utils/colors'
import Icon, { IconOption } from 'components/Icon'

const S = {
    Container: styled.div`
        display: flex;
        height: 52px;
        width: 100%;
        padding: 10px 37px;
        align-items: center;
        background-color: ${$white};
        border-bottom: 1px solid ${$gray_100};
        transition: background-color 250ms ease-in-out;

        &:hover {
            background-color: ${$gray_100};
            cursor: pointer;
        }
    `,
    Body: styled.div`
        flex-grow: 1;
        flex-shrink: 1;
        padding-right: 24px;
    `,
    Icon: styled(Icon)`
        margin-right: 20px;
    `
}

export interface ItemContainerProps {
    children?: ReactNode
    icon?: IconOption
    id: number
    onButtonEditClick(id: number): void
    onButtonDeleteClick(id: number): void
    showTranslatedIndicator?: boolean
    supportTranslate?: boolean
    isNative?: boolean
}

const ItemContainer: FC<ItemContainerProps> = ({
    children,
    icon = null,
    id,
    onButtonEditClick,
    onButtonDeleteClick,
    showTranslatedIndicator,
    supportTranslate,
}: ItemContainerProps) => {
    const buttonEditClickHandler = useCallback(() => {
        onButtonEditClick(id)
    }, [id, onButtonEditClick])

    const buttonDeleteClickHandler = useCallback(() => {
        onButtonDeleteClick(id)
    }, [id, onButtonDeleteClick])

    return (
        <S.Container>
            {icon && <S.Icon icon={icon} />}
            <S.Body>{children}</S.Body>
            {showTranslatedIndicator && (
                <S.Icon
                    icon="googleTranslate"
                    size={24}
                    color={supportTranslate ? colors.primary : colors.gray3}
                />
            )}
            <S.Icon icon="edit" onClick={buttonEditClickHandler} size={20} />
            <S.Icon icon="trash" onClick={buttonDeleteClickHandler} size={20} className="m-0" />
        </S.Container>
    )
}

export default ItemContainer
